import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/useAuth';
import { Loader2, ShieldX } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Page-level permission; omitted = any logged-in user. */
  permission?: string;
}

export default function ProtectedRoute({ children, permission }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, can } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-8 h-8 animate-spin text-purple-600" />
          <p className="text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (permission && !can(permission)) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <ShieldX className="w-10 h-10 text-gray-400 mb-3" />
        <h2 className="text-lg font-semibold text-gray-900">You don't have access to this page</h2>
        <p className="mt-1 text-sm text-gray-500">Ask an admin to give your role access.</p>
      </div>
    );
  }

  return <>{children}</>;
}
